export enum FilterFormField {
  dataSet = 'dataSet',
  influenceType = 'influenceType',
  model = 'model',
}
